import { createPayload } from 'optimistic/base'
import { selectCurrentTicket } from 'selectors/tickets'
import {
  selectCurrentUser,
  selectPreferences,
} from 'ducks/currentUser/selectors'
import { calculateConversationType } from 'util/draft'
import { toServerString } from 'util/date'
import {
  messageAction,
  statusAction,
  assignAgentAction,
  assignGroupAction,
  snoozeAction,
  unsnoozeAction,
  titleAction,
  assigneesDiffer,
} from './actions'

// builds mock data for a reply action.
export const messagePayload = (
  state,
  ticketId,
  draft,
  changesetId,
  folderId,
  search
) => {
  const { undo_send_delay: delaySeconds } = selectPreferences(state)
  const deliverBy = delaySeconds
    ? new Date(Date.now() + delaySeconds * 1000)
    : undefined
  const draftWithDeliverBy = delaySeconds ? { ...draft, deliverBy } : draft
  const actions = [messageAction(draftWithDeliverBy)]
  const ticket = selectCurrentTicket(state)
  const agent = selectCurrentUser(state)

  if (draft.snoozeUntil) {
    actions.push(snoozeAction(draft.snoozeUntil))
  } else if (ticket.state !== draft.state) {
    actions.push(statusAction(draft.state))
  }
  if (!draft.snoozeUntil && ticket.snoozeUntil) {
    actions.push(unsnoozeAction(draft.snoozeUntil))
  }

  if (assigneesDiffer(ticket, draft)) {
    actions.push(assignAgentAction(draft.assignee))
  }

  if (ticket.assigned_group_id !== draft.assigned_group_id) {
    actions.push(assignGroupAction(draft.assigned_group_id))
  }

  if (draft.title && ticket.title !== draft.title) {
    actions.push(titleAction(draft.title))
  }

  const ticketData = {
    id: ticketId,
    assigned_group_id: draft.assigned_group_id,
    assignee: draft.assignee,
    state: draft.state,
    to: draft.to,
    cc: draft.cc,
    bcc: draft.bcc,
    note: draft.isNote,
    mailboxId: draft.mailboxId,
    snoozedUntil: draft.snoozedUntil,
    updated_at: toServerString(new Date()),
    latest_collaborator_comment_at: toServerString(new Date()),
    bodyType: calculateConversationType(draft),
    title: draft.title,
    bodyAuthor: {
      id: agent.id,
      type: 'Agent',
    },
  }

  // Remove undefined props. This prevents downstream
  // issues where we clear out legitimate values from
  // the store because there is an undefined field in
  // the ticketData payload
  Object.keys(ticketData).forEach(key => {
    if (ticketData[key] === undefined) {
      delete ticketData[key]
    }
  })

  return createPayload(
    state,
    ticketId,
    'message',
    ticketData,
    actions,
    folderId,
    search,
    changesetId ? `optimistic-${changesetId}` : null
  )
}
